import type { Dossier } from '@/mocks/dossiers';

export default function TimelineSection({ dossier }: { dossier: Dossier }) {
  return (
    <section id="timeline" className="scroll-mt-24">
      <header className="flex flex-wrap items-center gap-3">
        <span className="flex h-9 w-9 items-center justify-center rounded-md bg-secondary-500 text-background-50">
          <i className="ri-time-line text-lg" />
        </span>
        <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">时间线关键节点</h2>
      </header>
      <p className="mt-3 font-body text-sm leading-relaxed text-foreground-600">
        按发生顺序排开，深色标记的是真正改变走向的关键节点。
      </p>

      <ol className="relative mt-8 space-y-7 border-l border-background-300 pl-6">
        {dossier.timeline.map((node) => (
          <li key={node.time} className="relative">
            <span
              className={`absolute -left-[31px] top-1 h-3.5 w-3.5 rounded-full border-2 ${
                node.tone === 'key'
                  ? 'border-primary-500 bg-primary-500'
                  : 'border-background-400 bg-background-50'
              }`}
            />
            <div className="flex flex-wrap items-center gap-2">
              <span className="font-label text-xs tracking-wide text-foreground-500">{node.time}</span>
              {node.tone === 'key' && (
                <span className="whitespace-nowrap rounded-full bg-primary-50 px-2 py-0.5 font-label text-[10px] text-primary-700">
                  关键节点
                </span>
              )}
            </div>
            <h3 className="mt-2 font-heading text-base font-semibold text-foreground-950">{node.title}</h3>
            <p className="mt-2 font-body text-sm leading-relaxed text-foreground-600">{node.desc}</p>
          </li>
        ))}
      </ol>
    </section>
  );
}